var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWsc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 638.934,
    height: 730.07,
    viewBox: "0 0 638.934 730.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#cae4f2;}.b{fill:#c8e1ba;}.c{fill:#bbb8ce;}.d{fill:#ebeaf0;}.e{fill:#9593b5;}.f{fill:#48a3d4;}.g,.k,.y{fill:#ffcc85;}.g{opacity:0.64;}.h{fill:#7cbde0;}.i{fill:#380200;}.j{fill:#736374;}.k{opacity:0.36;}.l{fill:#b9eaf0;}.m{fill:#00a1be;}.n{fill:#6f7bc4;}.o{fill:#2e96ce;}.p{fill:#5c4556;}.q{fill:#3d283c;}.r{fill:#b06c49;}.s{fill:#3e0100;}.t{fill:#fff;}.u{fill:#ddd9eb;}.v{fill:#0090a8;}.w{fill:#5ba532;}.x{fill:#6daf48;}.z{fill:#a5a4c0;}.aa{fill:#fcfdf7;}.ab{fill:#743d2b;}.ac{fill:#064966;}.ad{fill:#1489c8;}.ae{fill:#78a83f;}.af{fill:#6195ce;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-59.811 -38.927)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.811 38.927)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 449.584)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(175.411 33.942)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(196.901 83.848)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M317.292,394.758l98.478,56.856a12.8,12.8,0,0,0,11.584,0h0c3.2-1.846,3.2-4.841,0-6.687l-98.478-56.856a12.8,12.8,0,0,0-11.584,0h0C314.094,389.917,314.094,392.912,317.292,394.758Z",
    transform: "translate(-238.817 -342.763)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M274.013,369.771l52.044,30.048a12.809,12.809,0,0,0,11.584,0h0c3.2-1.847,3.2-4.841,0-6.689L285.6,363.084a12.8,12.8,0,0,0-11.584,0h0C270.815,364.93,270.815,367.925,274.013,369.771Z",
    transform: "translate(-271.615 -361.699)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M300.684,368.2l98.478,56.856a12.809,12.809,0,0,0,11.584,0h0c3.2-1.847,3.2-4.841,0-6.688L312.268,361.51a12.809,12.809,0,0,0-11.584,0h0C297.485,363.357,297.485,366.351,300.684,368.2Z",
    transform: "translate(-54.503 -279.043)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M229.047,326.838l98.478,56.856a12.8,12.8,0,0,0,11.584,0h0c3.2-1.847,3.2-4.841,0-6.688L240.631,320.15a12.809,12.809,0,0,0-11.584,0h0C225.848,322,225.848,324.993,229.047,326.838Z",
    transform: "translate(-108.79 -310.386)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M196.872,342.207l98.478,56.856a12.809,12.809,0,0,0,11.584,0h0c3.2-1.847,3.2-4.843,0-6.688l-98.478-56.856a12.8,12.8,0,0,0-11.584,0h0C193.673,337.366,193.673,340.359,196.872,342.207Z",
    transform: "translate(-133.173 -298.741)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M302.594,403.244l28.825,16.643a12.809,12.809,0,0,0,11.584,0h0c3.2-1.847,3.2-4.841,0-6.688l-28.825-16.641a12.8,12.8,0,0,0-11.584,0h0C299.4,398.4,299.4,401.4,302.594,403.244Z",
    transform: "translate(-53.055 -252.485)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M162,322.073l28.825,16.641a12.8,12.8,0,0,0,11.584,0h0c3.2-1.847,3.2-4.841,0-6.688l-28.825-16.641a12.8,12.8,0,0,0-11.584,0h0C158.8,317.232,158.8,320.225,162,322.073Z",
    transform: "translate(-159.6 -313.999)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M289.539,344.792l98.48,56.856a12.806,12.806,0,0,0,11.582,0h0c3.2-1.848,3.2-4.841,0-6.689L301.123,338.1a12.809,12.809,0,0,0-11.584,0h0C286.341,339.951,286.341,342.945,289.539,344.792Z",
    transform: "translate(-62.948 -296.781)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M254.666,324.658,283.492,341.3a12.794,12.794,0,0,0,11.582,0h0c3.2-1.846,3.2-4.841,0-6.687L266.25,317.97a12.81,12.81,0,0,0-11.584,0h0C251.468,319.817,251.468,322.811,254.666,324.658Z",
    transform: "translate(-89.375 -312.038)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.448 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(196.901 83.848)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M227.429,375.451l98.478,56.855a12.8,12.8,0,0,0,11.584,0h0c3.2-1.846,3.2-4.841,0-6.687l-98.478-56.856a12.8,12.8,0,0,0-11.584,0h0C224.23,370.608,224.23,373.6,227.429,375.451Z",
    transform: "translate(-148.955 -323.454)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M184.15,350.462l52.044,30.048a12.809,12.809,0,0,0,11.584,0h0c3.2-1.848,3.2-4.841,0-6.688l-52.044-30.046a12.8,12.8,0,0,0-11.584,0h0C180.952,345.621,180.952,348.616,184.15,350.462Z",
    transform: "translate(-181.752 -342.39)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M210.821,348.889,309.3,405.746a12.81,12.81,0,0,0,11.584,0h0c3.2-1.847,3.2-4.841,0-6.688L222.405,342.2a12.809,12.809,0,0,0-11.584,0h0C207.622,344.048,207.622,347.042,210.821,348.889Z",
    transform: "translate(35.36 -259.734)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M139.184,307.529l98.478,56.856a12.8,12.8,0,0,0,11.584,0h0c3.2-1.846,3.2-4.841,0-6.689l-98.48-56.855a12.8,12.8,0,0,0-11.582,0h0C135.985,302.688,135.985,305.683,139.184,307.529Z",
    transform: "translate(-18.927 -291.077)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M107.009,322.9l98.478,56.856a12.809,12.809,0,0,0,11.584,0h0c3.2-1.847,3.2-4.841,0-6.688l-98.478-56.856a12.8,12.8,0,0,0-11.584,0h0C103.81,318.057,103.81,321.05,107.009,322.9Z",
    transform: "translate(-43.31 -279.432)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M212.731,383.935l28.825,16.643a12.8,12.8,0,0,0,11.584,0h0c3.2-1.847,3.2-4.841,0-6.688l-28.825-16.641a12.8,12.8,0,0,0-11.584,0h0C209.532,379.094,209.532,382.089,212.731,383.935Z",
    transform: "translate(36.808 -233.176)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M72.136,302.764,100.961,319.4a12.8,12.8,0,0,0,11.584,0h0c3.2-1.846,3.2-4.841,0-6.688L83.72,296.075a12.8,12.8,0,0,0-11.584,0h0C68.937,297.923,68.937,300.916,72.136,302.764Z",
    transform: "translate(-69.737 -294.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M199.676,325.483l98.478,56.856a12.809,12.809,0,0,0,11.584,0h0c3.2-1.847,3.2-4.841,0-6.688L211.26,318.795a12.809,12.809,0,0,0-11.584,0h0C196.478,320.642,196.478,323.636,199.676,325.483Z",
    transform: "translate(26.915 -277.472)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M164.8,305.349l28.825,16.641a12.8,12.8,0,0,0,11.584,0h0c3.2-1.846,3.2-4.841,0-6.687l-28.825-16.643a12.81,12.81,0,0,0-11.584,0h0C161.605,300.508,161.605,303.5,164.8,305.349Z",
    transform: "translate(0.488 -292.73)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 111.7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(196.9 83.847)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M174.224,414.007l52.042,30.046a12.8,12.8,0,0,0,11.584,0h0c3.2-1.846,3.2-4.841,0-6.687l-52.042-30.048a12.81,12.81,0,0,0-11.584,0h0C171.025,409.166,171.025,412.16,174.224,414.007Z",
    transform: "translate(-171.825 -405.935)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M200.894,412.433l98.478,56.856a12.8,12.8,0,0,0,11.584,0h0c3.2-1.846,3.2-4.841,0-6.687l-98.478-56.856a12.8,12.8,0,0,0-11.584,0h0C197.7,407.592,197.7,410.587,200.894,412.433Z",
    transform: "translate(45.286 -323.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M129.257,371.075l98.478,56.856a12.809,12.809,0,0,0,11.584,0h0c3.2-1.847,3.2-4.841,0-6.688l-98.478-56.856a12.8,12.8,0,0,0-11.584,0h0C126.058,366.234,126.058,369.227,129.257,371.075Z",
    transform: "translate(-9.002 -354.623)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M97.082,386.441l98.48,56.856a12.8,12.8,0,0,0,11.582,0h0c3.2-1.846,3.2-4.841,0-6.687l-98.478-56.856a12.8,12.8,0,0,0-11.584,0h0C93.884,381.6,93.884,384.6,97.082,386.441Z",
    transform: "translate(-33.384 -342.977)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M202.805,447.48l28.825,16.643a12.809,12.809,0,0,0,11.584,0h0c3.2-1.847,3.2-4.841,0-6.688l-28.826-16.643a12.806,12.806,0,0,0-11.582,0h0C199.606,442.639,199.606,445.633,202.805,447.48Z",
    transform: "translate(46.734 -296.721)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M62.209,366.307,91.035,382.95a12.806,12.806,0,0,0,11.582,0h0c3.2-1.848,3.2-4.841,0-6.689L73.793,359.62a12.8,12.8,0,0,0-11.584,0h0C59.011,361.466,59.011,364.461,62.209,366.307Z",
    transform: "translate(-59.811 -358.235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M189.75,389.027l98.478,56.856a12.8,12.8,0,0,0,11.584,0h0c3.2-1.846,3.2-4.841,0-6.687L201.334,382.34a12.8,12.8,0,0,0-11.584,0h0C186.551,384.186,186.551,387.181,189.75,389.027Z",
    transform: "translate(36.841 -341.017)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M154.877,368.893,183.7,385.536a12.8,12.8,0,0,0,11.584,0h0c3.2-1.848,3.2-4.841,0-6.689L166.46,362.206a12.8,12.8,0,0,0-11.582,0h0C151.678,364.052,151.678,367.047,154.877,368.893Z",
    transform: "translate(10.414 -356.275)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.08)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M74.258,216.2V553.726L378.309,379.85V42.325Z",
    transform: "translate(-62.942 -36.351)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M79.137,481.272,67.821,474.95V137.935l11.316,5.813Z",
    transform: "translate(-67.821 36.103)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M67.821,212.964,371.1,38.927l12.09,5.974L79.137,218.777Z",
    transform: "translate(-67.821 -38.927)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.316 33.764)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 32.007)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M74.258,250.617l51.536,29.159L429.587,105.5,378.051,76.343Z",
    transform: "translate(-74.258 -76.343)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M125.795,204.644v13.562L74.258,189.048V175.486Z",
    transform: "translate(-74.258 -1.212)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M103.577,280.767,407.369,105.244V92.931L103.577,267.2Z",
    transform: "translate(-52.041 -63.773)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.139)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(270.116)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M255.8,92.268c-4.537,2.621-11.892,2.621-16.427,0s-4.537-6.864,0-9.483,11.89-2.619,16.427,0S260.335,89.651,255.8,92.268Z",
    transform: "translate(-235.968 -40.943)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M259.2,70.242H235.968v25.3c0,1.717,1.134,3.433,3.4,4.743,4.535,2.621,11.89,2.621,16.427,0,2.268-1.308,3.4-3.025,3.4-4.741h0Z",
    transform: "translate(-235.968 -48.959)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M239.371,92.385c4.535,2.619,11.89,2.619,16.427,0,2.268-1.31,3.4-3.025,3.4-4.743V71.817l-.033,0c-.141,1.6-1.253,3.171-3.368,4.393-4.537,2.619-11.892,2.619-16.427,0-2.109-1.218-3.224-2.786-3.373-4.38h-.03V87.646C235.97,89.362,237.1,91.077,239.371,92.385Z",
    transform: "translate(-235.968 -47.766)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M255.8,77.875c-4.537,2.619-11.892,2.619-16.427,0s-4.537-6.866,0-9.483,11.89-2.619,16.427,0S260.335,75.256,255.8,77.875Z",
    transform: "translate(-235.968 -51.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M255.8,73.169c-4.537,2.619-11.892,2.619-16.427,0s-4.537-6.864,0-9.483,11.89-2.619,16.427,0S260.335,70.55,255.8,73.169Z",
    transform: "translate(-235.968 -55.416)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 23.232,
    height: 6.305,
    transform: "translate(0 6.707)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M255.8,69.584c-4.537,2.617-11.892,2.617-16.427,0s-4.537-6.866,0-9.485,11.89-2.619,16.427,0S260.335,66.965,255.8,69.584Z",
    transform: "translate(-235.968 -58.135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M249.582,65.767a9.615,9.615,0,0,1-8.7,0c-2.4-1.389-2.4-3.639,0-5.026a9.615,9.615,0,0,1,8.7,0C251.987,62.128,251.987,64.378,249.582,65.767Z",
    transform: "translate(-233.614 -56.949)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.604 14.81)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M270.364,100.693c-4.537,2.619-11.892,2.619-16.427,0s-4.537-6.864,0-9.483,11.89-2.619,16.427,0S274.9,98.074,270.364,100.693Z",
    transform: "translate(-250.534 -49.368)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M273.765,78.667H250.534v25.3c0,1.717,1.134,3.433,3.4,4.743,4.535,2.619,11.89,2.619,16.427,0,2.268-1.31,3.4-3.025,3.4-4.743h0Z",
    transform: "translate(-250.534 -57.384)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M253.937,100.811c4.535,2.619,11.89,2.619,16.427,0,2.268-1.31,3.4-3.025,3.4-4.743V80.241l-.033,0c-.141,1.6-1.253,3.173-3.368,4.393-4.537,2.619-11.892,2.619-16.427,0-2.109-1.216-3.224-2.784-3.373-4.379h-.03V96.07C250.536,97.786,251.67,99.5,253.937,100.811Z",
    transform: "translate(-250.534 -56.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M270.364,86.3c-4.537,2.619-11.892,2.619-16.427,0s-4.537-6.866,0-9.485,11.89-2.619,16.427,0S274.9,83.682,270.364,86.3Z",
    transform: "translate(-250.534 -60.276)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M270.364,81.594c-4.537,2.619-11.892,2.619-16.427,0s-4.537-6.866,0-9.483,11.89-2.619,16.427,0S274.9,78.975,270.364,81.594Z",
    transform: "translate(-250.534 -63.841)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 23.232,
    height: 6.305,
    transform: "translate(0 6.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M270.364,78.007c-4.537,2.619-11.892,2.619-16.427,0s-4.537-6.864,0-9.483,11.89-2.619,16.427,0S274.9,75.388,270.364,78.007Z",
    transform: "translate(-250.534 -66.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M264.148,74.192a9.626,9.626,0,0,1-8.7,0c-2.4-1.389-2.4-3.639,0-5.026a9.615,9.615,0,0,1,8.7,0C266.553,70.553,266.553,72.8,264.148,74.192Z",
    transform: "translate(-248.18 -65.374)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(209.308 14.197)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M244.125,72.449l-31.82,17.246-10.931-6.073,31.057-17.411Z",
    transform: "translate(-201.375 -66.211)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M212.305,82.189v49.434l-10.931-6.379V76.116Z",
    transform: "translate(-201.375 -58.705)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M201.375,80.961V99.379l10.931,6.073V87.034Z",
    transform: "translate(-201.375 -55.033)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M239.413,69.76l-31.82,17.246V136.44l31.82-18.074Z",
    transform: "translate(-196.662 -63.522)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M207.593,91.854v18.392L239.413,93V74.608Z",
    transform: "translate(-196.662 -59.848)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.058 10.51)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M254.4,78.428l-31.82,17.246L211.648,89.6,242.7,72.19Z",
    transform: "translate(-211.648 -72.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M222.578,88.168V137.6l-10.931-6.379V82.1Z",
    transform: "translate(-211.648 -64.684)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M211.648,86.94v18.418l10.931,6.073V93.013Z",
    transform: "translate(-211.648 -61.012)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M249.686,75.739l-31.82,17.246v49.434l31.82-18.074Z",
    transform: "translate(-206.935 -69.501)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M217.866,97.833v18.392l31.82-17.246V80.587Z",
    transform: "translate(-206.935 -65.827)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.115 21.02)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M264.671,84.407l-31.82,17.246L221.92,95.58l31.057-17.411Z",
    transform: "translate(-221.92 -78.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M232.851,94.147v49.434L221.92,137.2V88.074Z",
    transform: "translate(-221.92 -70.663)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M221.92,92.919v18.418l10.931,6.073V98.992Z",
    transform: "translate(-221.92 -66.991)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M259.959,81.718l-31.82,17.246V148.4l31.82-18.074Z",
    transform: "translate(-217.208 -75.48)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M228.139,103.812V122.2l31.82-17.246V86.566Z",
    transform: "translate(-217.208 -71.806)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(166.837 38.647)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M219.964,86.358,188.144,103.6l-10.931-6.073L208.271,80.12Z",
    transform: "translate(-177.213 -80.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M188.144,96.1v49.434l-10.931-6.379V90.025Z",
    transform: "translate(-177.213 -72.614)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M177.214,94.87v18.418l10.931,6.073V100.943Z",
    transform: "translate(-177.213 -68.942)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M215.252,83.669l-31.82,17.246v49.434l31.82-18.074Z",
    transform: "translate(-172.501 -77.431)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M183.432,105.763v18.392l31.82-17.246V88.517Z",
    transform: "translate(-172.501 -73.757)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.058 10.51)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M230.237,92.337l-31.82,17.246-10.931-6.073L218.544,86.1Z",
    transform: "translate(-187.486 -86.099)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M198.417,102.077v49.434l-10.931-6.379V96Z",
    transform: "translate(-187.486 -78.593)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M187.486,100.85v18.418l10.931,6.073V106.922Z",
    transform: "translate(-187.486 -74.921)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M225.525,89.648,193.7,106.894v49.434l31.82-18.074Z",
    transform: "translate(-182.774 -83.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M193.7,111.742v18.392l31.82-17.246V94.5Z",
    transform: "translate(-182.774 -79.736)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.115 21.02)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M240.51,98.316l-31.82,17.246-10.931-6.073,31.057-17.411Z",
    transform: "translate(-197.759 -92.078)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M208.69,108.056V157.49l-10.931-6.379V101.983Z",
    transform: "translate(-197.759 -84.572)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M197.759,106.829v18.418l10.931,6.073V112.9Z",
    transform: "translate(-197.759 -80.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M235.8,95.627l-31.82,17.246v49.434l31.82-18.074Z",
    transform: "translate(-193.047 -89.389)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M203.977,117.721v18.392l31.82-17.246V100.475Z",
    transform: "translate(-193.047 -85.715)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124.366 63.097)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M195.8,100.267l-31.82,17.246-10.931-6.073,31.057-17.411Z",
    transform: "translate(-153.052 -94.029)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M163.983,110.007v49.434l-10.931-6.379V103.934Z",
    transform: "translate(-153.052 -86.523)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M153.052,108.78V127.2l10.931,6.073V114.852Z",
    transform: "translate(-153.052 -82.852)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M191.091,97.578l-31.82,17.246v49.434l31.82-18.074Z",
    transform: "translate(-148.34 -91.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M159.27,119.673v18.392l31.82-17.246V102.426Z",
    transform: "translate(-148.34 -87.666)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.058 10.51)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M206.076,106.246l-31.82,17.246-10.931-6.073,31.058-17.411Z",
    transform: "translate(-163.325 -100.008)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M174.256,115.986V165.42l-10.931-6.379V109.913Z",
    transform: "translate(-163.325 -92.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M163.325,114.759v18.418l10.93,6.073V120.831Z",
    transform: "translate(-163.325 -88.831)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M201.363,103.557,169.543,120.8v49.434l31.82-18.074Z",
    transform: "translate(-158.613 -97.319)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M169.543,125.652v18.392l31.82-17.246V108.406Z",
    transform: "translate(-158.613 -93.645)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.115 21.02)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M216.348,112.225l-31.82,17.246L173.6,123.4l31.057-17.411Z",
    transform: "translate(-173.598 -105.987)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M184.528,121.965V171.4L173.6,165.02V115.892Z",
    transform: "translate(-173.598 -98.481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M173.6,120.738v18.418l10.931,6.073V126.81Z",
    transform: "translate(-173.598 -94.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M211.636,109.536l-31.82,17.246v49.434l31.82-18.074Z",
    transform: "translate(-168.885 -103.298)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M179.816,131.631v18.392l31.82-17.246V114.384Z",
    transform: "translate(-168.885 -99.624)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99.947 98.534)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M158.991,148.325c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.485,11.892-2.619,16.429,0S163.526,145.706,158.991,148.325Z",
    transform: "translate(-139.161 -96.998)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M162.392,126.3H139.161v25.3c0,1.716,1.134,3.433,3.4,4.743,4.537,2.619,11.892,2.619,16.429,0,2.268-1.31,3.4-3.027,3.4-4.743h0Z",
    transform: "translate(-139.161 -105.014)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M142.562,148.442c4.537,2.617,11.892,2.617,16.429,0,2.268-1.311,3.4-3.027,3.4-4.743h0V127.872l-.033,0c-.141,1.6-1.253,3.171-3.368,4.393-4.537,2.619-11.892,2.619-16.429,0-2.108-1.216-3.222-2.786-3.371-4.379h-.03V143.7C139.161,145.417,140.3,147.132,142.562,148.442Z",
    transform: "translate(-139.161 -103.821)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M158.991,133.93c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.864,0-9.483,11.892-2.619,16.429,0S163.526,131.311,158.991,133.93Z",
    transform: "translate(-139.161 -107.905)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M158.991,129.226c-4.537,2.617-11.892,2.617-16.429,0s-4.535-6.866,0-9.485,11.892-2.619,16.429,0S163.526,126.607,158.991,129.226Z",
    transform: "translate(-139.161 -111.471)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 23.232,
    height: 6.305,
    transform: "translate(0 6.707)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M158.991,125.639c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.485,11.892-2.619,16.429,0S163.526,123.02,158.991,125.639Z",
    transform: "translate(-139.161 -114.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M152.775,121.822a9.615,9.615,0,0,1-8.7,0c-2.4-1.387-2.4-3.639,0-5.026a9.615,9.615,0,0,1,8.7,0C155.18,118.183,155.18,120.435,152.775,121.822Z",
    transform: "translate(-136.807 -113.004)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.604 14.81)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M173.557,156.75c-4.537,2.619-11.892,2.619-16.428,0s-4.535-6.866,0-9.485,11.892-2.619,16.428,0S178.092,154.131,173.557,156.75Z",
    transform: "translate(-153.727 -105.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M176.958,134.722H153.727v25.3c0,1.717,1.134,3.435,3.4,4.744,4.537,2.619,11.892,2.619,16.428,0,2.268-1.31,3.4-3.027,3.4-4.743h0Z",
    transform: "translate(-153.727 -113.439)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M157.128,156.865c4.537,2.619,11.892,2.619,16.428,0,2.268-1.31,3.4-3.025,3.4-4.741h0V136.3l-.033,0c-.141,1.6-1.253,3.173-3.368,4.395-4.537,2.619-11.892,2.619-16.428,0-2.108-1.218-3.222-2.786-3.371-4.38h-.03v15.813C153.727,153.842,154.863,155.557,157.128,156.865Z",
    transform: "translate(-153.727 -112.246)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M173.557,142.355c-4.537,2.619-11.892,2.619-16.428,0s-4.535-6.864,0-9.483,11.892-2.619,16.428,0S178.092,139.736,173.557,142.355Z",
    transform: "translate(-153.727 -116.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M173.557,137.649c-4.537,2.619-11.892,2.619-16.428,0s-4.535-6.864,0-9.483,11.892-2.619,16.428,0S178.092,135.032,173.557,137.649Z",
    transform: "translate(-153.727 -119.896)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 23.232,
    height: 6.305,
    transform: "translate(0 6.707)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M173.557,134.064c-4.537,2.619-11.892,2.619-16.428,0s-4.535-6.864,0-9.483,11.892-2.619,16.428,0S178.092,131.445,173.557,134.064Z",
    transform: "translate(-153.727 -122.615)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M167.341,130.247a9.615,9.615,0,0,1-8.7,0c-2.4-1.389-2.4-3.639,0-5.026a9.615,9.615,0,0,1,8.7,0C169.746,126.608,169.746,128.858,167.341,130.247Z",
    transform: "translate(-151.373 -121.429)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.372 119.197)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M139.89,160.078c-4.535,2.619-11.89,2.619-16.427,0s-4.537-6.864,0-9.483,11.892-2.619,16.427,0S144.427,157.459,139.89,160.078Z",
    transform: "translate(-120.06 -108.753)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M143.293,138.052H120.06v25.3c0,1.717,1.134,3.433,3.4,4.743,4.537,2.619,11.892,2.619,16.427,0,2.269-1.31,3.4-3.025,3.4-4.743h0Z",
    transform: "translate(-120.06 -116.769)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M123.463,160.2c4.537,2.619,11.892,2.619,16.427,0,2.269-1.31,3.4-3.025,3.4-4.743V139.626l-.033,0c-.141,1.6-1.255,3.173-3.37,4.393-4.535,2.619-11.89,2.619-16.427,0-2.108-1.216-3.224-2.784-3.373-4.379h-.03v15.813C120.062,157.172,121.2,158.886,123.463,160.2Z",
    transform: "translate(-120.06 -115.576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M139.89,145.686c-4.535,2.619-11.89,2.619-16.427,0s-4.537-6.866,0-9.485,11.892-2.619,16.427,0S144.427,143.067,139.89,145.686Z",
    transform: "translate(-120.06 -119.661)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M139.89,140.979c-4.535,2.619-11.89,2.619-16.427,0s-4.537-6.864,0-9.483,11.892-2.619,16.427,0S144.427,138.36,139.89,140.979Z",
    transform: "translate(-120.06 -123.226)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 23.232,
    height: 6.305,
    transform: "translate(0.001 6.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M139.89,137.392c-4.535,2.619-11.89,2.619-16.427,0s-4.537-6.864,0-9.483,11.892-2.619,16.427,0S144.427,134.773,139.89,137.392Z",
    transform: "translate(-120.06 -125.944)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M133.675,133.577a9.629,9.629,0,0,1-8.706,0c-2.4-1.389-2.4-3.639,0-5.027a9.629,9.629,0,0,1,8.706,0C136.078,129.938,136.078,132.188,133.675,133.577Z",
    transform: "translate(-117.706 -124.759)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.604 14.81)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M154.456,168.5c-4.535,2.619-11.89,2.619-16.427,0s-4.537-6.864,0-9.483,11.892-2.619,16.427,0S158.993,165.884,154.456,168.5Z",
    transform: "translate(-134.626 -117.178)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M157.859,146.477H134.626v25.3c0,1.716,1.134,3.433,3.4,4.743,4.537,2.619,11.892,2.619,16.427,0,2.269-1.31,3.4-3.025,3.4-4.743h0Z",
    transform: "translate(-134.626 -125.194)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M138.029,168.621c4.537,2.619,11.892,2.619,16.427,0,2.269-1.31,3.4-3.025,3.4-4.743V148.051l-.033,0c-.142,1.6-1.255,3.173-3.37,4.393-4.535,2.619-11.89,2.619-16.427,0-2.108-1.216-3.224-2.786-3.373-4.379h-.03V163.88C134.628,165.6,135.762,167.311,138.029,168.621Z",
    transform: "translate(-134.626 -124.001)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M154.456,154.111c-4.535,2.619-11.89,2.619-16.427,0s-4.537-6.866,0-9.485,11.892-2.619,16.427,0S158.993,151.492,154.456,154.111Z",
    transform: "translate(-134.626 -128.086)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M154.456,149.4c-4.535,2.619-11.89,2.619-16.427,0s-4.537-6.866,0-9.485,11.892-2.619,16.427,0S158.993,146.786,154.456,149.4Z",
    transform: "translate(-134.626 -131.652)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 23.232,
    height: 6.305,
    transform: "translate(0.001 6.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M154.456,145.817c-4.535,2.619-11.89,2.619-16.427,0s-4.537-6.866,0-9.483,11.892-2.619,16.427,0S158.993,143.2,154.456,145.817Z",
    transform: "translate(-134.626 -134.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M148.241,142a9.629,9.629,0,0,1-8.706,0c-2.4-1.389-2.4-3.639,0-5.027a9.629,9.629,0,0,1,8.706,0C150.644,138.363,150.644,140.613,148.241,142Z",
    transform: "translate(-132.272 -133.184)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.797 139.86)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M120.79,171.834c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.485,11.892-2.619,16.429,0S125.325,169.215,120.79,171.834Z",
    transform: "translate(-100.96 -120.508)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M124.191,149.807H100.96v25.3c0,1.716,1.134,3.433,3.4,4.743,4.537,2.619,11.892,2.619,16.429,0,2.268-1.31,3.4-3.025,3.4-4.743h0Z",
    transform: "translate(-100.96 -128.524)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M104.361,171.951c4.537,2.619,11.892,2.619,16.429,0,2.268-1.31,3.4-3.027,3.4-4.743h0V151.381l-.033,0c-.141,1.6-1.253,3.173-3.368,4.393-4.537,2.619-11.892,2.619-16.429,0-2.108-1.216-3.222-2.786-3.371-4.379h-.03V167.21C100.96,168.926,102.1,170.641,104.361,171.951Z",
    transform: "translate(-100.96 -127.331)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M120.79,157.441c-4.537,2.617-11.892,2.617-16.429,0s-4.535-6.866,0-9.485,11.892-2.619,16.429,0S125.325,154.822,120.79,157.441Z",
    transform: "translate(-100.96 -131.415)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M120.79,152.735c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.485,11.892-2.619,16.429,0S125.325,150.116,120.79,152.735Z",
    transform: "translate(-100.96 -134.982)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 23.232,
    height: 6.305,
    transform: "translate(0 6.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M120.79,149.147c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.485,11.892-2.617,16.429,0S125.325,146.528,120.79,149.147Z",
    transform: "translate(-100.96 -137.699)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M114.574,145.332a9.626,9.626,0,0,1-8.7,0c-2.4-1.389-2.4-3.639,0-5.027a9.626,9.626,0,0,1,8.7,0C116.979,141.693,116.979,143.943,114.574,145.332Z",
    transform: "translate(-98.606 -136.513)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.604 14.808)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M135.356,180.259c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.485,11.892-2.619,16.429,0S139.891,177.64,135.356,180.259Z",
    transform: "translate(-115.526 -128.932)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M138.757,158.232H115.526v25.3c0,1.716,1.134,3.433,3.4,4.743,4.537,2.619,11.892,2.619,16.429,0,2.268-1.31,3.4-3.027,3.4-4.743h0Z",
    transform: "translate(-115.526 -136.948)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M118.927,180.374c4.537,2.619,11.892,2.619,16.429,0,2.268-1.31,3.4-3.025,3.4-4.741h0V159.806l-.033,0c-.141,1.6-1.253,3.171-3.368,4.393-4.537,2.619-11.892,2.619-16.429,0-2.108-1.218-3.222-2.786-3.371-4.379h-.03v15.812C115.526,177.351,116.662,179.066,118.927,180.374Z",
    transform: "translate(-115.526 -135.755)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M135.356,165.864c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.864,0-9.483,11.892-2.619,16.429,0S139.891,163.245,135.356,165.864Z",
    transform: "translate(-115.526 -139.839)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M135.356,161.16c-4.537,2.617-11.892,2.617-16.429,0s-4.535-6.866,0-9.485,11.892-2.619,16.429,0S139.891,158.541,135.356,161.16Z",
    transform: "translate(-115.526 -143.405)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 23.232,
    height: 6.305,
    transform: "translate(0 6.707)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M135.356,157.573c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.485,11.892-2.619,16.429,0S139.891,154.954,135.356,157.573Z",
    transform: "translate(-115.526 -146.124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M129.14,153.756a9.615,9.615,0,0,1-8.7,0c-2.4-1.387-2.4-3.639,0-5.026a9.615,9.615,0,0,1,8.7,0C131.545,150.117,131.545,152.369,129.14,153.756Z",
    transform: "translate(-113.172 -144.938)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 157.906)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M102.132,182.1c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.864,0-9.483,11.892-2.619,16.429,0S106.667,179.48,102.132,182.1Z",
    transform: "translate(-82.302 -130.774)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M105.533,160.073H82.3v25.3c0,1.717,1.134,3.433,3.4,4.743,4.537,2.619,11.892,2.619,16.429,0,2.268-1.31,3.4-3.025,3.4-4.741h0Z",
    transform: "translate(-82.302 -138.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M85.7,182.217c4.537,2.619,11.892,2.619,16.429,0,2.268-1.31,3.4-3.025,3.4-4.743V161.647l-.033,0c-.141,1.6-1.253,3.173-3.368,4.393-4.537,2.619-11.892,2.619-16.429,0-2.108-1.216-3.222-2.784-3.371-4.379H82.3v15.812C82.3,179.192,83.438,180.907,85.7,182.217Z",
    transform: "translate(-82.302 -137.597)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M102.132,167.707c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.485,11.892-2.619,16.429,0S106.667,165.088,102.132,167.707Z",
    transform: "translate(-82.302 -141.682)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M102.132,163c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.483,11.892-2.619,16.429,0S106.667,160.381,102.132,163Z",
    transform: "translate(-82.302 -145.247)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 23.232,
    height: 6.305,
    transform: "translate(0 6.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M102.132,159.413c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.864,0-9.483,11.892-2.619,16.429,0S106.667,156.794,102.132,159.413Z",
    transform: "translate(-82.302 -147.966)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M95.916,155.6a9.626,9.626,0,0,1-8.7,0c-2.4-1.389-2.4-3.639,0-5.027a9.626,9.626,0,0,1,8.7,0C98.321,151.959,98.321,154.209,95.916,155.6Z",
    transform: "translate(-79.948 -146.78)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.604 14.809)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M116.7,190.525c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.483,11.892-2.619,16.429,0S121.233,187.905,116.7,190.525Z",
    transform: "translate(-96.868 -139.199)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M120.1,168.5H96.868v25.3c0,1.716,1.134,3.433,3.4,4.743,4.537,2.619,11.892,2.619,16.429,0,2.268-1.31,3.4-3.025,3.4-4.743h0Z",
    transform: "translate(-96.868 -147.215)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M100.269,190.642c4.537,2.619,11.892,2.619,16.429,0,2.268-1.31,3.4-3.027,3.4-4.743h0V170.072l-.033,0c-.141,1.6-1.253,3.173-3.368,4.393-4.537,2.619-11.892,2.619-16.429,0-2.108-1.216-3.222-2.786-3.371-4.379h-.03V185.9C96.868,187.617,98,189.332,100.269,190.642Z",
    transform: "translate(-96.868 -146.022)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M116.7,176.132c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.485,11.892-2.619,16.429,0S121.233,173.513,116.7,176.132Z",
    transform: "translate(-96.868 -150.106)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M116.7,171.426c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.485,11.892-2.619,16.429,0S121.233,168.807,116.7,171.426Z",
    transform: "translate(-96.868 -153.673)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 23.232,
    height: 6.305,
    transform: "translate(0 6.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M116.7,167.838c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.485,11.892-2.617,16.429,0S121.233,165.219,116.7,167.838Z",
    transform: "translate(-96.868 -156.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M110.482,164.023a9.626,9.626,0,0,1-8.7,0c-2.4-1.389-2.4-3.639,0-5.027a9.626,9.626,0,0,1,8.7,0C112.887,160.384,112.887,162.634,110.482,164.023Z",
    transform: "translate(-94.514 -155.204)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.316 187.553)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 32.007)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M74.258,338.106l51.536,29.159L429.587,192.991l-51.536-29.159Z",
    transform: "translate(-74.258 -163.832)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M125.795,292.133V305.7L74.258,276.537V262.975Z",
    transform: "translate(-74.258 -88.701)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M103.577,368.256,407.369,192.733V180.42L103.577,354.694Z",
    transform: "translate(-52.041 -151.262)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.139)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(270.116)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M255.8,179.759c-4.537,2.619-11.892,2.619-16.427,0s-4.537-6.866,0-9.485,11.89-2.619,16.427,0S260.335,177.14,255.8,179.759Z",
    transform: "translate(-235.968 -128.432)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M259.2,157.731H235.968v25.3c0,1.717,1.134,3.435,3.4,4.744,4.535,2.619,11.89,2.619,16.427,0,2.268-1.31,3.4-3.027,3.4-4.743h0Z",
    transform: "translate(-235.968 -136.448)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M239.371,179.874c4.535,2.619,11.89,2.619,16.427,0,2.268-1.31,3.4-3.025,3.4-4.741h0V159.306l-.033,0c-.141,1.6-1.253,3.173-3.368,4.395-4.537,2.619-11.892,2.619-16.427,0-2.109-1.218-3.224-2.786-3.373-4.38h-.03v15.813C235.97,176.851,237.1,178.566,239.371,179.874Z",
    transform: "translate(-235.968 -135.255)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M255.8,165.364c-4.537,2.619-11.892,2.619-16.427,0s-4.537-6.864,0-9.483,11.89-2.619,16.427,0S260.335,162.745,255.8,165.364Z",
    transform: "translate(-235.968 -139.339)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M255.8,160.658c-4.537,2.619-11.892,2.619-16.427,0s-4.537-6.864,0-9.483,11.89-2.619,16.427,0S260.335,158.041,255.8,160.658Z",
    transform: "translate(-235.968 -142.905)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 23.232,
    height: 6.305,
    transform: "translate(0 6.707)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M255.8,157.073c-4.537,2.619-11.892,2.619-16.427,0s-4.537-6.866,0-9.485,11.89-2.619,16.427,0S260.335,154.454,255.8,157.073Z",
    transform: "translate(-235.968 -145.624)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M249.582,153.256a9.615,9.615,0,0,1-8.7,0c-2.4-1.387-2.4-3.639,0-5.026a9.615,9.615,0,0,1,8.7,0C251.987,149.617,251.987,151.869,249.582,153.256Z",
    transform: "translate(-233.614 -144.437)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.604 14.81)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M270.364,188.182c-4.537,2.619-11.892,2.619-16.427,0s-4.537-6.864,0-9.483,11.89-2.619,16.427,0S274.9,185.563,270.364,188.182Z",
    transform: "translate(-250.534 -136.857)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M273.765,166.156H250.534v25.3c0,1.717,1.134,3.433,3.4,4.743,4.535,2.619,11.89,2.619,16.427,0,2.268-1.31,3.4-3.025,3.4-4.741h0Z",
    transform: "translate(-250.534 -144.873)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M253.937,188.3c4.535,2.619,11.89,2.619,16.427,0,2.268-1.31,3.4-3.025,3.4-4.743V167.73l-.033,0c-.141,1.6-1.253,3.173-3.368,4.393-4.537,2.619-11.892,2.619-16.427,0-2.109-1.216-3.224-2.784-3.373-4.379h-.03v15.811C250.536,185.277,251.67,186.99,253.937,188.3Z",
    transform: "translate(-250.534 -143.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M270.364,173.79c-4.537,2.619-11.892,2.619-16.427,0s-4.537-6.866,0-9.485,11.89-2.619,16.427,0S274.9,171.171,270.364,173.79Z",
    transform: "translate(-250.534 -147.765)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M270.364,169.083c-4.537,2.619-11.892,2.619-16.427,0s-4.537-6.864,0-9.483,11.89-2.619,16.427,0S274.9,166.464,270.364,169.083Z",
    transform: "translate(-250.534 -151.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 23.232,
    height: 6.305,
    transform: "translate(0 6.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M270.364,165.5c-4.537,2.619-11.892,2.619-16.427,0s-4.537-6.864,0-9.483,11.89-2.619,16.427,0S274.9,162.877,270.364,165.5Z",
    transform: "translate(-250.534 -154.048)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M264.148,161.681a9.626,9.626,0,0,1-8.7,0c-2.4-1.389-2.4-3.639,0-5.026a9.615,9.615,0,0,1,8.7,0C266.553,158.042,266.553,160.292,264.148,161.681Z",
    transform: "translate(-248.18 -152.863)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(209.308 14.197)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M244.125,159.938l-31.82,17.246-10.931-6.073L232.432,153.7Z",
    transform: "translate(-201.375 -153.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M212.305,169.678v49.434l-10.931-6.379V163.605Z",
    transform: "translate(-201.375 -146.194)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M201.375,168.45v18.418l10.931,6.073V174.523Z",
    transform: "translate(-201.375 -142.522)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M239.413,157.249l-31.82,17.246v49.434l31.82-18.074Z",
    transform: "translate(-196.662 -151.011)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M207.593,179.343v18.392l31.82-17.246V162.1Z",
    transform: "translate(-196.662 -147.337)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.058 10.51)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M254.4,165.917l-31.82,17.246-10.931-6.073L242.7,159.679Z",
    transform: "translate(-211.648 -159.679)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M222.578,175.657v49.434l-10.931-6.379V169.584Z",
    transform: "translate(-211.648 -152.173)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M211.648,174.429v18.418l10.931,6.073V180.5Z",
    transform: "translate(-211.648 -148.501)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M249.686,163.228l-31.82,17.246v49.434l31.82-18.074Z",
    transform: "translate(-206.935 -156.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M217.866,185.322v18.392l31.82-17.246V168.076Z",
    transform: "translate(-206.935 -153.316)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.115 21.02)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M264.671,171.9l-31.82,17.246-10.931-6.073,31.057-17.411Z",
    transform: "translate(-221.92 -165.658)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M232.851,181.636V231.07l-10.931-6.379V175.563Z",
    transform: "translate(-221.92 -158.152)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M221.92,180.408v18.418l10.931,6.073V186.481Z",
    transform: "translate(-221.92 -154.48)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M259.959,169.207l-31.82,17.246v49.434l31.82-18.074Z",
    transform: "translate(-217.208 -162.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M228.139,191.3v18.392l31.82-17.246V174.055Z",
    transform: "translate(-217.208 -159.295)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(166.837 38.647)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M219.964,173.847l-31.82,17.246-10.931-6.073,31.058-17.411Z",
    transform: "translate(-177.213 -167.609)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M188.144,183.587v49.434l-10.931-6.379V177.514Z",
    transform: "translate(-177.213 -160.103)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M177.214,182.359v18.418l10.931,6.073V188.432Z",
    transform: "translate(-177.213 -156.431)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M215.252,171.158,183.432,188.4v49.434l31.82-18.074Z",
    transform: "translate(-172.501 -164.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M183.432,193.253v18.392l31.82-17.246V176.007Z",
    transform: "translate(-172.501 -161.246)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.058 10.51)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M230.237,179.826l-31.82,17.246L187.486,191l31.057-17.411Z",
    transform: "translate(-187.486 -173.588)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M198.417,189.566V239l-10.931-6.379V183.493Z",
    transform: "translate(-187.486 -166.082)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M187.486,188.339v18.418l10.931,6.073V194.411Z",
    transform: "translate(-187.486 -162.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M225.525,177.137,193.7,194.383v49.434l31.82-18.074Z",
    transform: "translate(-182.774 -170.899)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M193.7,199.232v18.392l31.82-17.246V181.985Z",
    transform: "translate(-182.774 -167.225)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.115 21.02)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M240.51,185.8l-31.82,17.246-10.931-6.073,31.057-17.411Z",
    transform: "translate(-197.759 -179.567)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M208.69,195.545v49.434L197.759,238.6V189.472Z",
    transform: "translate(-197.759 -172.061)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M197.759,194.318v18.418l10.931,6.073V200.39Z",
    transform: "translate(-197.759 -168.389)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M235.8,183.116l-31.82,17.246V249.8l31.82-18.074Z",
    transform: "translate(-193.047 -176.878)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M203.977,205.211V223.6l31.82-17.246V187.964Z",
    transform: "translate(-193.047 -173.204)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124.366 63.096)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M195.8,187.756,163.983,205l-10.931-6.073,31.057-17.411Z",
    transform: "translate(-153.052 -181.518)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M163.983,197.5V246.93l-10.931-6.379V191.423Z",
    transform: "translate(-153.052 -174.012)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M153.052,196.269v18.418l10.931,6.073V202.341Z",
    transform: "translate(-153.052 -170.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M191.091,185.067l-31.82,17.246v49.434l31.82-18.074Z",
    transform: "translate(-148.34 -178.829)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M159.27,207.162v18.392l31.82-17.246V189.916Z",
    transform: "translate(-148.34 -175.155)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.058 10.51)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M206.076,193.735l-31.82,17.246-10.931-6.073L194.382,187.5Z",
    transform: "translate(-163.325 -187.497)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M174.256,203.475v49.434l-10.931-6.379V197.4Z",
    transform: "translate(-163.325 -179.991)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M163.325,202.248v18.418l10.93,6.073V208.32Z",
    transform: "translate(-163.325 -176.319)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M201.363,191.046l-31.82,17.246v49.434l31.82-18.074Z",
    transform: "translate(-158.613 -184.808)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M169.543,213.141v18.392l31.82-17.246V195.895Z",
    transform: "translate(-158.613 -181.134)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.115 21.02)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M216.348,199.714l-31.82,17.246L173.6,210.888l31.057-17.411Z",
    transform: "translate(-173.598 -193.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M184.528,209.454v49.434L173.6,252.509V203.381Z",
    transform: "translate(-173.598 -185.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M173.6,208.227v18.418l10.931,6.073V214.3Z",
    transform: "translate(-173.598 -182.299)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M211.636,197.025l-31.82,17.246v49.434l31.82-18.074Z",
    transform: "translate(-168.885 -190.787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M179.816,219.12v18.392l31.82-17.246V201.874Z",
    transform: "translate(-168.885 -187.113)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99.947 98.534)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M158.991,235.814c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.485,11.892-2.619,16.429,0S163.526,233.195,158.991,235.814Z",
    transform: "translate(-139.161 -184.487)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M162.392,213.787H139.161v25.3c0,1.716,1.134,3.433,3.4,4.743,4.537,2.619,11.892,2.619,16.429,0,2.268-1.31,3.4-3.027,3.4-4.743h0Z",
    transform: "translate(-139.161 -192.503)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M142.562,235.931c4.537,2.617,11.892,2.617,16.429,0,2.268-1.31,3.4-3.027,3.4-4.743h0V215.361l-.033,0c-.141,1.6-1.253,3.171-3.368,4.393-4.537,2.619-11.892,2.619-16.429,0-2.108-1.218-3.222-2.786-3.371-4.379h-.03V231.19C139.161,232.906,140.3,234.621,142.562,235.931Z",
    transform: "translate(-139.161 -191.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M158.991,221.419c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.864,0-9.483,11.892-2.619,16.429,0S163.526,218.8,158.991,221.419Z",
    transform: "translate(-139.161 -195.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M158.991,216.715c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.485,11.892-2.619,16.429,0S163.526,214.1,158.991,216.715Z",
    transform: "translate(-139.161 -198.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 23.232,
    height: 6.305,
    transform: "translate(0 6.707)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M158.991,213.128c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.485,11.892-2.619,16.429,0S163.526,210.509,158.991,213.128Z",
    transform: "translate(-139.161 -201.678)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M152.775,209.311a9.615,9.615,0,0,1-8.7,0c-2.4-1.387-2.4-3.637,0-5.026a9.615,9.615,0,0,1,8.7,0C155.18,205.674,155.18,207.924,152.775,209.311Z",
    transform: "translate(-136.807 -200.493)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.604 14.81)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M173.557,244.239c-4.537,2.617-11.892,2.617-16.428,0s-4.535-6.864,0-9.483,11.892-2.619,16.428,0S178.092,241.62,173.557,244.239Z",
    transform: "translate(-153.727 -192.912)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M176.958,222.211H153.727v25.3c0,1.717,1.134,3.433,3.4,4.743,4.537,2.619,11.892,2.619,16.428,0,2.268-1.31,3.4-3.027,3.4-4.743h0Z",
    transform: "translate(-153.727 -200.928)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M157.128,244.354c4.537,2.619,11.892,2.619,16.428,0,2.268-1.31,3.4-3.025,3.4-4.743V223.786l-.033,0c-.141,1.6-1.253,3.171-3.368,4.393-4.537,2.619-11.892,2.619-16.428,0-2.108-1.218-3.222-2.786-3.371-4.379h-.03v15.811C153.727,241.331,154.863,243.046,157.128,244.354Z",
    transform: "translate(-153.727 -199.735)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M173.557,229.844c-4.537,2.619-11.892,2.619-16.428,0s-4.535-6.866,0-9.483,11.892-2.619,16.428,0S178.092,227.225,173.557,229.844Z",
    transform: "translate(-153.727 -203.819)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M173.557,225.138c-4.537,2.619-11.892,2.619-16.428,0s-4.535-6.864,0-9.483,11.892-2.619,16.428,0S178.092,222.519,173.557,225.138Z",
    transform: "translate(-153.727 -207.385)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 23.232,
    height: 6.305,
    transform: "translate(0 6.707)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M173.557,221.553c-4.537,2.617-11.892,2.617-16.428,0s-4.535-6.866,0-9.485,11.892-2.619,16.428,0S178.092,218.934,173.557,221.553Z",
    transform: "translate(-153.727 -210.103)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M167.341,217.736a9.615,9.615,0,0,1-8.7,0c-2.4-1.387-2.4-3.639,0-5.026a9.615,9.615,0,0,1,8.7,0C169.746,214.1,169.746,216.349,167.341,217.736Z",
    transform: "translate(-151.373 -208.918)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.372 119.197)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M139.89,247.567c-4.535,2.619-11.89,2.619-16.427,0s-4.537-6.864,0-9.483,11.892-2.619,16.427,0S144.427,244.948,139.89,247.567Z",
    transform: "translate(-120.06 -196.242)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M143.293,225.541H120.06v25.3c0,1.717,1.134,3.433,3.4,4.743,4.537,2.619,11.892,2.619,16.427,0,2.269-1.31,3.4-3.025,3.4-4.741h0Z",
    transform: "translate(-120.06 -204.258)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M123.463,247.685c4.537,2.619,11.892,2.619,16.427,0,2.269-1.31,3.4-3.025,3.4-4.743V227.115l-.033,0c-.141,1.6-1.255,3.173-3.37,4.395-4.535,2.617-11.89,2.617-16.427,0-2.108-1.218-3.224-2.786-3.373-4.38h-.03v15.813C120.062,244.66,121.2,246.377,123.463,247.685Z",
    transform: "translate(-120.06 -203.065)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M139.89,233.174c-4.535,2.619-11.89,2.619-16.427,0s-4.537-6.866,0-9.485,11.892-2.617,16.427,0S144.427,230.555,139.89,233.174Z",
    transform: "translate(-120.06 -207.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M139.89,228.468c-4.535,2.619-11.89,2.619-16.427,0s-4.537-6.864,0-9.483,11.892-2.619,16.427,0S144.427,225.849,139.89,228.468Z",
    transform: "translate(-120.06 -210.715)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 23.232,
    height: 6.305,
    transform: "translate(0.001 6.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M139.89,224.881c-4.535,2.619-11.89,2.619-16.427,0s-4.537-6.864,0-9.483,11.892-2.619,16.427,0S144.427,222.264,139.89,224.881Z",
    transform: "translate(-120.06 -213.434)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M133.675,221.066a9.629,9.629,0,0,1-8.706,0c-2.4-1.389-2.4-3.639,0-5.026a9.618,9.618,0,0,1,8.706,0C136.078,217.427,136.078,219.677,133.675,221.066Z",
    transform: "translate(-117.706 -212.247)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.604 14.81)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M154.456,255.992c-4.535,2.619-11.89,2.619-16.427,0s-4.537-6.866,0-9.483,11.892-2.619,16.427,0S158.993,253.373,154.456,255.992Z",
    transform: "translate(-134.626 -204.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M157.859,233.966H134.626v25.3c0,1.717,1.134,3.433,3.4,4.743,4.537,2.619,11.892,2.619,16.427,0,2.269-1.31,3.4-3.025,3.4-4.743h0Z",
    transform: "translate(-134.626 -212.683)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M138.029,256.11c4.537,2.619,11.892,2.619,16.427,0,2.269-1.31,3.4-3.025,3.4-4.743h0V235.54l-.033,0c-.142,1.6-1.255,3.173-3.37,4.393-4.535,2.619-11.89,2.619-16.427,0-2.108-1.216-3.224-2.784-3.373-4.379h-.03v15.812C134.628,253.085,135.762,254.8,138.029,256.11Z",
    transform: "translate(-134.626 -211.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M154.456,241.6c-4.535,2.619-11.89,2.619-16.427,0s-4.537-6.866,0-9.485,11.892-2.619,16.427,0S158.993,238.981,154.456,241.6Z",
    transform: "translate(-134.626 -215.575)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M154.456,236.893c-4.535,2.619-11.89,2.619-16.427,0s-4.537-6.866,0-9.483,11.892-2.619,16.427,0S158.993,234.274,154.456,236.893Z",
    transform: "translate(-134.626 -219.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 23.232,
    height: 6.305,
    transform: "translate(0.001 6.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M154.456,233.306c-4.535,2.619-11.89,2.619-16.427,0s-4.537-6.864,0-9.483,11.892-2.619,16.427,0S158.993,230.687,154.456,233.306Z",
    transform: "translate(-134.626 -221.858)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M148.241,229.491a9.629,9.629,0,0,1-8.706,0c-2.4-1.389-2.4-3.639,0-5.027a9.629,9.629,0,0,1,8.706,0C150.644,225.852,150.644,228.1,148.241,229.491Z",
    transform: "translate(-132.272 -220.673)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.797 139.859)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M120.79,259.322c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.485,11.892-2.617,16.429,0S125.325,256.7,120.79,259.322Z",
    transform: "translate(-100.96 -207.996)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M124.191,237.3H100.96v25.3c0,1.716,1.134,3.433,3.4,4.743,4.537,2.619,11.892,2.619,16.429,0,2.268-1.31,3.4-3.025,3.4-4.743h0Z",
    transform: "translate(-100.96 -216.012)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M104.361,259.44c4.537,2.619,11.892,2.619,16.429,0,2.268-1.31,3.4-3.027,3.4-4.743h0V238.87l-.033,0c-.141,1.6-1.253,3.173-3.368,4.393-4.537,2.619-11.892,2.619-16.429,0-2.108-1.216-3.222-2.786-3.371-4.379h-.03V254.7C100.96,256.415,102.1,258.13,104.361,259.44Z",
    transform: "translate(-100.96 -214.819)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M120.79,244.93c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.485,11.892-2.619,16.429,0S125.325,242.311,120.79,244.93Z",
    transform: "translate(-100.96 -218.903)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M120.79,240.224c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.485,11.892-2.619,16.429,0S125.325,237.6,120.79,240.224Z",
    transform: "translate(-100.96 -222.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 23.232,
    height: 6.305,
    transform: "translate(0 6.707)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M120.79,236.637c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.483,11.892-2.621,16.429,0S125.325,234.018,120.79,236.637Z",
    transform: "translate(-100.96 -225.188)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M114.574,232.819a9.615,9.615,0,0,1-8.7,0c-2.4-1.387-2.4-3.637,0-5.026a9.626,9.626,0,0,1,8.7,0C116.979,229.182,116.979,231.432,114.574,232.819Z",
    transform: "translate(-98.606 -224.001)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.604 14.809)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M135.356,267.748c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.485,11.892-2.619,16.429,0S139.891,265.129,135.356,267.748Z",
    transform: "translate(-115.526 -216.421)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M138.757,245.721H115.526v25.3c0,1.716,1.134,3.433,3.4,4.743,4.537,2.619,11.892,2.619,16.429,0,2.268-1.31,3.4-3.027,3.4-4.743h0Z",
    transform: "translate(-115.526 -224.437)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M118.927,267.865c4.537,2.619,11.892,2.619,16.429,0,2.268-1.31,3.4-3.027,3.4-4.743h0V247.295l-.033,0c-.141,1.6-1.253,3.171-3.368,4.393-4.537,2.619-11.892,2.619-16.429,0-2.108-1.216-3.222-2.786-3.371-4.379h-.03v15.811C115.526,264.84,116.662,266.555,118.927,267.865Z",
    transform: "translate(-115.526 -223.244)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M135.356,253.353c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.864,0-9.483,11.892-2.619,16.429,0S139.891,250.736,135.356,253.353Z",
    transform: "translate(-115.526 -227.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M135.356,248.649c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.485,11.892-2.619,16.429,0S139.891,246.03,135.356,248.649Z",
    transform: "translate(-115.526 -230.894)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 23.232,
    height: 6.305,
    transform: "translate(0 6.707)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M135.356,245.062c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.485,11.892-2.619,16.429,0S139.891,242.443,135.356,245.062Z",
    transform: "translate(-115.526 -233.612)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M129.14,241.245a9.615,9.615,0,0,1-8.7,0c-2.4-1.387-2.4-3.637,0-5.026a9.615,9.615,0,0,1,8.7,0C131.545,237.608,131.545,239.858,129.14,241.245Z",
    transform: "translate(-113.172 -232.427)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 157.906)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M102.132,269.588c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.864,0-9.483,11.892-2.619,16.429,0S106.667,266.969,102.132,269.588Z",
    transform: "translate(-82.302 -218.263)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M105.533,247.562H82.3v25.3c0,1.717,1.134,3.433,3.4,4.743,4.537,2.619,11.892,2.619,16.429,0,2.268-1.31,3.4-3.025,3.4-4.741h0Z",
    transform: "translate(-82.302 -226.279)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M85.7,269.706c4.537,2.619,11.892,2.619,16.429,0,2.268-1.31,3.4-3.025,3.4-4.743V249.136l-.033,0c-.141,1.6-1.253,3.173-3.368,4.393-4.537,2.619-11.892,2.619-16.429,0-2.108-1.216-3.222-2.784-3.371-4.379H82.3v15.812C82.3,266.681,83.438,268.4,85.7,269.706Z",
    transform: "translate(-82.302 -225.086)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M102.132,255.2c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.485,11.892-2.619,16.429,0S106.667,252.577,102.132,255.2Z",
    transform: "translate(-82.302 -229.171)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M102.132,250.489c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.864,0-9.483,11.892-2.619,16.429,0S106.667,247.87,102.132,250.489Z",
    transform: "translate(-82.302 -232.736)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 23.232,
    height: 6.305,
    transform: "translate(0 6.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M102.132,246.9c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.864,0-9.483,11.892-2.619,16.429,0S106.667,244.283,102.132,246.9Z",
    transform: "translate(-82.302 -235.454)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M95.916,243.087a9.626,9.626,0,0,1-8.7,0c-2.4-1.389-2.4-3.639,0-5.027a9.626,9.626,0,0,1,8.7,0C98.321,239.448,98.321,241.7,95.916,243.087Z",
    transform: "translate(-79.948 -234.269)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.604 14.81)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M116.7,278.013c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.483,11.892-2.619,16.429,0S121.233,275.394,116.7,278.013Z",
    transform: "translate(-96.868 -226.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M120.1,255.987H96.868v25.3c0,1.716,1.134,3.433,3.4,4.743,4.537,2.619,11.892,2.619,16.429,0,2.268-1.31,3.4-3.025,3.4-4.743h0Z",
    transform: "translate(-96.868 -234.704)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M100.269,278.131c4.537,2.619,11.892,2.619,16.429,0,2.268-1.31,3.4-3.027,3.4-4.743h0V257.561l-.033,0c-.141,1.6-1.253,3.173-3.368,4.393-4.537,2.619-11.892,2.619-16.429,0-2.108-1.216-3.222-2.786-3.371-4.379h-.03V273.39C96.868,275.106,98,276.821,100.269,278.131Z",
    transform: "translate(-96.868 -233.512)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M116.7,263.621c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.485,11.892-2.619,16.429,0S121.233,261,116.7,263.621Z",
    transform: "translate(-96.868 -237.596)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M116.7,258.915c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.485,11.892-2.619,16.429,0S121.233,256.3,116.7,258.915Z",
    transform: "translate(-96.868 -241.162)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 23.232,
    height: 6.305,
    transform: "translate(0 6.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M116.7,255.327c-4.537,2.619-11.892,2.619-16.429,0s-4.535-6.866,0-9.483,11.892-2.619,16.429,0S121.233,252.708,116.7,255.327Z",
    transform: "translate(-96.868 -243.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M110.482,251.512a9.625,9.625,0,0,1-8.7,0c-2.4-1.389-2.4-3.639,0-5.027a9.626,9.626,0,0,1,8.7,0C112.887,247.873,112.887,250.123,110.482,251.512Z",
    transform: "translate(-94.514 -242.694)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(147.427 154.043)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M249.851,305.453s-20.971,15.43-80.327,10.638L188.266,202.98l49.075-1.895S228.448,269.01,249.851,305.453Z",
    transform: "translate(-138.176 -70.084)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.267 178.356)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M232.415,353.723c7.864,3.822,15.079,7.875,12.918,11.705-9.355,11.962-22.433-.453-30.31-2.858-7.026-2.129-22.525,3.711-21.63-12.723Z",
    transform: "translate(-168.383 -135.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M204.149,442.086a40.013,40.013,0,0,1,1.085-7.1c2.159-11.185-11.661-44.851-11.185-57.015.473-12.132,4.518-26.738,4.518-26.738s-21-64.392-19.306-102.389,44.824-12.1,44.824-12.1.99,110.82-3.528,117.049c-1.695,2.164,1.16,77.866,6.161,83.343,2.3,2.544,13.129,7.226,16.453,8.826C244.763,461.2,204.149,442.086,204.149,442.086Z",
    transform: "translate(-179.139 -227.945)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M201.869,433.15c7.815,7.288,17.378,5.657,23.95,2.268-1.577-9.058-1.587-72.3,0-74.327,1.594-17.508-1.724-124.346-1.724-124.346s-43.128-25.894-44.824,12.1c-1.232,27.626,7.2,75.538,12.649,104.354,2.54,13.43.956,24.251,1.137,27.561C194.79,412.249,201.916,432.935,201.869,433.15Z",
    transform: "translate(-179.149 -227.945)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M204.787,419.941c-1.012-24.9,1.348-49.748,1.6-74.63.216-21.41-4.837-43.087-1.983-64.39,2.106-15.708,1.985-31.941,13.2-42.534-.076-2.54-36.636-27.459-38.333,10.54-1.232,27.626,7.2,75.538,12.649,104.354,2.54,13.43.956,24.251,1.137,27.561,1.733,31.486,8.859,52.172,8.812,52.386a19.23,19.23,0,0,0,5.563,3.658A82.451,82.451,0,0,1,204.787,419.941Z",
    transform: "translate(-179.149 -228.025)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.192 185.749)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M202.662,369.339c7.641,5.11,17.133,8.824,14.333,12.505-15.55,15.4-25.859-2.153-33.717-5.79-7.012-3.226-23.991.628-20.7-16.357Z",
    transform: "translate(-158.948 -135.635)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M163.113,456.293a42.105,42.105,0,0,1,2.148-7.237c3.857-11.338-5.7-48.384-3.456-60.986,2.234-12.567,8.546-27.2,8.546-27.2s-12.621-70.079-5.395-109.41,48.421-6.165,48.421-6.165S198.485,360.857,192.887,366.7c-2.078,2.011-9.979,81.26-5.558,87.683,2.034,2.981,12.635,9.413,15.866,11.556C202.664,482.036,163.113,456.293,163.113,456.293Z",
    transform: "translate(-159.48 -232.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M162.864,446.655c7.093,8.713,17.286,8.388,24.618,5.8-.341-9.661,8.733-75.524,10.679-77.409,4.177-18.007,16.07-129.749,16.07-129.749s-41.2-33.165-48.421,6.165c-5.254,28.594-3.357,79.7-1.821,110.5.715,14.351-2.487,25.393-2.774,28.865C158.494,423.872,162.945,446.438,162.864,446.655Z",
    transform: "translate(-160.333 -232.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M169.755,421.968c.529-19.823-.039-39.755,3.4-59.372,3.561-20.326,7.655-43.012,26.161-51.8,19.521-9.276,8.752-47.387,8.613-69.217a3.986,3.986,0,0,1,.06-.645c-11.8-7.48-36.712-19.22-42.177,10.536-5.254,28.594-3.357,79.7-1.821,110.5.715,14.351-2.489,25.393-2.774,28.865-2.721,33.042,1.73,55.608,1.649,55.825a20.181,20.181,0,0,0,5.535,4.776C168.519,441.6,169.5,431.708,169.755,421.968Z",
    transform: "translate(-160.333 -232.23)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M179.837,142.252s1.174,22.27-15.2,38.8-9.62,42.028,24.349,35.047,31.054-14,38.1-20.853,9.339-55.034-15.662-60.214S179.837,142.252,179.837,142.252Z",
    transform: "translate(-148.336 -121.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M198.445,156.368l9.039,11.944,4.751,22.291-3.711,12.56-18.088,3.313-15.46-6.616s-6.734-3.013-2.185-19.753c14.328-7.153,11.037-26.367,11.037-26.367Z",
    transform: "translate(-136.896 -105.962)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.563 59.95)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.157 72.944)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M210.6,202.171a104.669,104.669,0,0,1,10.431,6.727c7.474,5.372,15.782,12.194,27.733,20.7a13.013,13.013,0,0,0,4.108.686c1.592-.647,3.762-1.292,5.774-1.949a16.45,16.45,0,0,1,7.239.417c5.792,1.876,9.336-1.487,11.524.128-.517,3.387-4.49,4.839-8.715,5.412,4.254,2,11.389,5,15.145,6.843,4.95,2.431,3.041,5.625-4.386,4.642-5.293-.7-11.67,2.642-15.894,1.823a27.98,27.98,0,0,1-11.584-5.143s-4.939-5.126-11-6.581c-10.424-4.658-18.531-6.7-26.784-9.849a88.947,88.947,0,0,1-10.712-4.853C203.461,220.651,196.134,201.7,210.6,202.171Z",
    transform: "translate(-200.582 -202.162)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M248.375,246.167c2.556-1.895,1.267-13.373,2.556-16.123a5.652,5.652,0,0,1-1.724-.445c-11.951-8.508-20.259-15.33-27.733-20.7a104.674,104.674,0,0,0-10.431-6.727c-14.467-.469-9.016,18.462-8.993,18.986C205.768,223.159,244.96,245.371,248.375,246.167Z",
    transform: "translate(-201.025 -202.162)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M244.726,236.617c-8.517-4.857-17.151-9.5-25.39-14.829-6.917-4.472-13.642-10.206-16.87-17.211-2.965,5.488-.434,14.393-.418,14.75,3.718,2,42.91,24.214,46.325,25.01.868-.643,1.288-2.4,1.52-4.535C248.2,238.7,246.484,237.619,244.726,236.617Z",
    transform: "translate(-201.023 -200.332)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M192.971,160.665s16.339,4.539,19.252,17.17c2.839,12.658,2.547,32.208,2.547,32.208l-17.842-26.235Z",
    transform: "translate(-192.971 -160.665)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.303 60.998)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M168.051,249.733a195.247,195.247,0,0,1,8.445,17.828c7.453,12.44,25.683,30.936,41.926,27.858a53.376,53.376,0,0,0,19.454-8c-1.714-12.285.056-49.88.056-49.88s9.995-4.456,9.995-15.826c0-11.392-25.784-46.716-31.635-60.451h-6.235s13.685,23.525,3.607,29.747c-9.633,6.028-33.1-16.6-33.1-16.6s-6.356,6.019-12.421,11.37a21.16,21.16,0,0,0-6.994,18.608C163.34,221.238,168.051,249.733,168.051,249.733Z",
    transform: "translate(-160.965 -161.261)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M218.873,289.656a33.34,33.34,0,0,1,1.245-4.621c2.276-6.479,6.353-11.781,6.738-18.9.367-6.773-2.57-12.268-4.09-18.642a4.2,4.2,0,0,1-.112-.821,52.606,52.606,0,0,1-1.781-9.371c-.823-7.337-1.74-15.748-4.723-22.41a186.451,186.451,0,0,1-10.554-29.222c-10.842-3.25-25.037-16.931-25.037-16.931s-6.356,6.019-12.421,11.37a21.16,21.16,0,0,0-6.994,18.608c2.2,16.852,6.908,45.348,6.908,45.348a195.248,195.248,0,0,1,8.445,17.828c7.455,12.44,25.683,30.936,41.926,27.858C218.572,289.723,218.722,289.686,218.873,289.656Z",
    transform: "translate(-160.965 -155.593)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 65.275)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M196.289,163.694s14.829,21.744,23.1,35.239,7.645,65.025,7.645,65.025l-7.645,100.709s-47.482,4.576-67.693-17.037c-.192-43.639,30.354-54.83,28.737-73.6-2.431-28.2-19.092-57.449-12.435-83.4C167.993,190.629,182.676,171.646,196.289,163.694Z",
    transform: "translate(-151.69 -163.694)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M184.7,189.577a49.327,49.327,0,0,0-13.206-8.771c-3.122,24.713,6.734,54.7,8.937,80.256,1.617,18.77-28.928,29.96-28.737,73.6,7.427,7.942,18.538,12.34,29.623,14.736-11.756-16.638-4.547-24.18.341-43.339,5.892-23.091,11.767-55.626,10.049-80.031C190.831,213.614,187.6,201.626,184.7,189.577Z",
    transform: "translate(-151.69 -150.726)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M174.817,205.047c5.342,24.115,27.042,9.58,27.042,9.58S183,222.238,174.817,205.047Z",
    transform: "translate(-134.165 -132.356)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M208.326,168.651s-8.049-7.095-18.125-8.8c0,0,22.743,37.241,25.193,55.364s1.484,143.52,1.484,143.52,12.09-9.552,17.3-22.041c0,0-5.562-31.1-10.338-50.7s3.976-42.439,1.927-63.221-11.638-28.865-13.579-38.417S208.326,168.651,208.326,168.651Z",
    transform: "translate(-122.507 -101.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M197.835,159.162l9.5,9.211,4.261,16.058-1.751,5.723,5.889,2.148s10.385,34.747,2.487,89.336c0,0,1.005-51.894-8.376-81.515-7.247-22.88-21.407-42.6-21.407-42.6Z",
    transform: "translate(-123.846 -103.098)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.349)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M198.239,131.386s17.981,17.3,0,30.32Z",
    transform: "translate(-147.764 -122.903)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M181.864,133.224c4.27-3.533,19.324-7.566,29.171-.257,4.482,3.328,11.252,11.28,7.613,32.015-2.9,24.305-12.563,24.305-15.841,25.093-11.18-.788-16.131-9.021-19.886-13.131C169.782,162.569,167.676,144.967,181.864,133.224Z",
    transform: "translate(-167.565 -124.801)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M223.283,141.052c-5.068-14.664-23.073-16.465-33.332-12.962-12.466,4.257-21.872,10.934-20.243,25.439.905,8.074,3.582,16.564,8.752,22.945,2.421,2.987,4.83,6.2,6.483,8.474.209-1.378,1.361-4.639,1.067-5.483a21.537,21.537,0,0,1-.635-9.571c.3-1.993,2.835-3.117,4.6-2.612a3.867,3.867,0,0,1,2.61,4.6,6.763,6.763,0,0,0,.121,2.232,16.669,16.669,0,0,0,2.021-5.857c.742-6.249,15.318-11.232,15.318-11.232S228.352,155.715,223.283,141.052Z",
    transform: "translate(-169.524 -126.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M189.076,153.369c1.179,4.555-.042,8.808-2.726,9.5s-5.818-2.433-7-6.986.042-8.808,2.728-9.5S187.9,148.816,189.076,153.369Z",
    transform: "translate(-162.417 -111.61)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.754 87.056)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M183.472,238.272s8.545-1.76,9.8-2.011,4.523,0,8.293,2.011,11.308,4.022,13.822,3.268,3.266,5.277-2.514,5.277-8.8-2.262-9.55,0,5.53,8.293,10.3,8.8,7.791.251,8.293,2.009-2.262,2.765-5.78,3.268-10.053,2.763-18.6-1.508-12.313-8.582-16.082-10.322S183.472,238.272,183.472,238.272Z",
    transform: "translate(-135.851 -130.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M159.9,210.55s-1.754-40.4,18.754-33.718c13.7,4.449,8.608,23.854,8.608,23.854s-7.3,38.814-11.435,56.63c0,0,13.714,15.664,27.559,26.334-1.269,4.405-2.807,14.8-4.083,16.954-10.865-4.924-40.108-26.269-43.525-32.454C152.572,262.1,159.9,210.55,159.9,210.55Z",
    transform: "translate(-154.964 -176.085)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M177.35,276.565c-4.9-3.412-9.693-7.095-11.886-12.865-2.842-7.472-1.568-16.072-.218-23.729,1.872-10.621,12.556-51.572-.958-59.753-5.128,10.111-4.391,27.2-4.391,27.2s-7.325,51.551-4.122,57.6c3.417,6.186,32.66,27.531,43.525,32.454.047-.081.1-.2.148-.3C192.423,289.948,185.713,282.387,177.35,276.565Z",
    transform: "translate(-154.964 -172.953)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M182.665,162.341l.879-3.887-6.068,2.82-1.689,8.5-3.676,4.187,14.194,21.255,11.167,3.359-2.586,8.321s14.669,35.411,15.645,74.53c0,0,5.985-28.909-3.329-75.359C207.2,206.063,195.645,178.757,182.665,162.341Z",
    transform: "translate(-136.216 -102.39)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(201.086 337.461)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.826)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M236.505,398.425v158.4l232.12-134.63v-156Z",
    transform: "translate(-141.075 -207.987)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(190.687 154.27)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M302.531,332.793v71.286L322.937,391.9v-71.06Z",
    transform: "translate(-281.727 -320.844)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M352.64,327.783l-61.944,35.2V386.71l61.944-35.423Z",
    transform: "translate(-290.696 -315.585)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M277.646,365.51l-95.43-55.881V468.5l95.43,55.408Z",
    transform: "translate(-182.216 -175.072)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M182.216,367.638,417.181,233.081l92.585,58.207L277.646,423.519Z",
    transform: "translate(-182.216 -233.081)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.227 114.202)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M219.97,325.173a13.1,13.1,0,0,1-11.846,0c-3.271-1.89-3.271-4.952,0-6.841a13.1,13.1,0,0,1,11.846,0C223.241,320.221,223.241,323.283,219.97,325.173Z",
    transform: "translate(-205.67 -279.927)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 16.754,
    height: 19.107,
    transform: "translate(0.001 22.719)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M219.97,314.3a13.1,13.1,0,0,1-11.846,0c-3.271-1.89-3.271-4.952,0-6.84a13.1,13.1,0,0,1,11.846,0C223.241,309.35,223.241,312.412,219.97,314.3Z",
    transform: "translate(-205.67 -288.163)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.378)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M217.264,309.677a9.38,9.38,0,0,1-8.483,0c-2.343-1.352-2.343-3.545,0-4.9a9.369,9.369,0,0,1,8.483,0C219.607,306.131,219.607,308.325,217.264,309.677Z",
    transform: "translate(-207.023 -289.893)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 11.998,
    height: 4.07,
    transform: "translate(0 13.265)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M217.264,307.361a9.369,9.369,0,0,1-8.483,0c-2.343-1.352-2.343-3.546,0-4.9a9.369,9.369,0,0,1,8.483,0C219.607,303.815,219.607,306.009,217.264,307.361Z",
    transform: "translate(-207.023 -291.648)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M214.09,305.529a5.027,5.027,0,0,1-4.54,0,1.383,1.383,0,0,1,0-2.621,5.016,5.016,0,0,1,4.54,0A1.383,1.383,0,0,1,214.09,305.529Z",
    transform: "translate(-205.821 -290.953)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M211.82,295.873a1.914,1.914,0,0,1,1.853,1.348,4.947,4.947,0,0,1,.271,1.227v5.792a6.7,6.7,0,0,0,.258,2.489,12.751,12.751,0,0,1,.828,2.408h-6.42a12.861,12.861,0,0,1,.826-2.408,6.7,6.7,0,0,0,.258-2.489v-5.792a4.947,4.947,0,0,1,.271-1.227A1.917,1.917,0,0,1,211.82,295.873Z",
    transform: "translate(-205.82 -295.873)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M208.124,313.7c-1.635-.944-2.454-2.181-2.454-3.421v14.344c0,1.236.819,2.473,2.454,3.417a13.262,13.262,0,0,0,10.953.448V314.145A13.249,13.249,0,0,1,208.124,313.7Z",
    transform: "translate(-205.67 -284.957)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.945 122.17)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M243.191,333.658c-4.586,2.647-12.02,2.647-16.606,0s-4.586-6.94,0-9.587,12.02-2.647,16.606,0S247.775,331.011,243.191,333.658Z",
    transform: "translate(-223.145 -283.976)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 23.483,
    height: 26.782,
    transform: "translate(0.001 18.106)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M243.191,318.422c-4.586,2.647-12.02,2.647-16.606,0s-4.586-6.94,0-9.587,12.02-2.647,16.606,0S247.775,315.775,243.191,318.422Z",
    transform: "translate(-223.145 -295.522)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.334)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M239.4,311.939a13.148,13.148,0,0,1-11.892,0c-3.284-1.9-3.284-4.969,0-6.866a13.148,13.148,0,0,1,11.892,0C242.68,306.969,242.68,310.042,239.4,311.939Z",
    transform: "translate(-225.042 -297.946)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 16.817,
    height: 5.706,
    transform: "translate(0 4.854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M239.4,308.693a13.148,13.148,0,0,1-11.892,0c-3.284-1.9-3.284-4.969,0-6.866a13.148,13.148,0,0,1,11.892,0C242.68,303.723,242.68,306.8,239.4,308.693Z",
    transform: "translate(-225.042 -300.405)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M226.586,317.575c-2.294-1.32-3.44-3.057-3.44-4.8v20.108c0,1.733,1.146,3.466,3.44,4.792,4.185,2.415,10.754,2.628,15.353.628V318.2C237.34,320.207,230.771,320,226.586,317.575Z",
    transform: "translate(-223.145 -291.028)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117.358)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M270.293,305.54l21.8,14.489,26.147-13.6v-1.5l-20.77-15.275Z",
    transform: "translate(-232.829 -186.377)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M270.293,304.689l21.8,14.489,26.147-13.6-20.77-16.77Z",
    transform: "translate(-232.829 -187.022)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M355.322,232.29,250.979,293.069v83.264L355.322,315.2Z",
    transform: "translate(-247.465 -229.855)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M356.836,233.34l-5.4-2.435-102.454,59.7v83.967l3.513,2.811V294.119Z",
    transform: "translate(-248.98 -230.905)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M304.391,278.047l7.585,38.668-26.146,13.6-9.146-41.741a6.438,6.438,0,0,1,3.3-7.08l15.1-7.908A6.437,6.437,0,0,1,304.391,278.047Z",
    transform: "translate(-228.099 -199.123)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M305.265,278.6l7.587,38.67-26.147,13.6-9.146-41.741a6.438,6.438,0,0,1,3.3-7.08l15.1-7.908A6.437,6.437,0,0,1,305.265,278.6Z",
    transform: "translate(-227.436 -198.706)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(246.495 4.717)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M365.2,239.826l-31.82,17.246L322.444,251,353.5,233.588Z",
    transform: "translate(-322.444 -233.588)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M333.375,249.566V299l-10.931-6.379V243.493Z",
    transform: "translate(-322.444 -226.082)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M322.444,248.338v18.418l10.931,6.073V254.411Z",
    transform: "translate(-322.444 -222.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M360.483,237.137l-31.82,17.246v49.434l31.82-18.074Z",
    transform: "translate(-317.732 -230.899)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M328.663,259.231v18.392l31.82-17.246V241.985Z",
    transform: "translate(-317.732 -227.225)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsc);
export default __webpack_public_path__ + "static/media/wsc.e15e079481d0959eccfdc1ea18d0c5e5.svg";
export { ForwardRef as ReactComponent };